import React, {useMemo} from "react"
import {useTranslation} from "react-i18next"
import {Department} from "types/departments"
import {KlassDropdown, KlassDropdownProps} from "../Select"
import {pick} from "lodash"
import {useAllDepartments, useModel} from "hooks"
import {BaseDepartmentPermission, PermissionType} from "types/permission"
import {checkBaseDepartmentPermission} from "helpers"

type Props = Partial<KlassDropdownProps> & {baseDepartmentPermission?: BaseDepartmentPermission}

const DepartmentSelect: React.FC<Props> = ({baseDepartmentPermission, ...props}) => {
    const {t} = useTranslation(["common"])
    const {departments} = useAllDepartments()
    const model = useModel()

    const options = useMemo(() => {
        if (baseDepartmentPermission) {
            return departments
                .filter((item) =>
                    checkBaseDepartmentPermission(
                        PermissionType.View,
                        model,
                        item.departmentId,
                        baseDepartmentPermission
                    )
                )
                .map((item) => pick(item, ["departmentId", "code", "name"]))
        }
        return departments.map((item) => pick(item, ["departmentId", "code", "name"]))
    }, [baseDepartmentPermission, departments, model])

    return (
        <KlassDropdown
            {...props}
            placeholder={props.placeholder || t("selectField.placeholder")}
            options={options}
            valueKey="departmentId"
            labelKey="name"
            getOptionLabel={(option: Department) => option.name}
        />
    )
}

export default DepartmentSelect
